module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAc0lEQVQ4EaXBsQ0DQQzAMGn/oR2VBxeBgSflI/lIlgkHhsgy4cAQWSYcGCLLhANDZJnwMPwhy4SH4Q9ZJhwYIsuEA0NkmXBgiCwTDgyRZcLDkAkPQ2SZ8DBkwsMQWSYcGCLLhANDZJlwYIgsEw4MkY/kox8j8kgVpG7rcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_06.png
// module id = 239
// module chunks = 0